export enum Method {
    GET,
    PUT,
    DELETE,
    POST,
    PATCH,
    HEAD
}


// WEBPACK FOOTER //
// ./Client/Services/HttpMethods.ts